import { render, staticRenderFns } from "./add-friend-info.vue?vue&type=template&id=3dd33a3b&scoped=true&"
import script from "./add-friend-info.vue?vue&type=script&lang=js&"
export * from "./add-friend-info.vue?vue&type=script&lang=js&"
import style0 from "./add-friend-info.vue?vue&type=style&index=0&id=3dd33a3b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd33a3b",
  null
  
)

export default component.exports